import { CAT_NEWSLETTER_EMAILS } from 'App/utils/Collections';
import { FT_DATE, FT_AUTOCOMPLETE, FT_LIST } from '../FilterTypes';
import { searchNewsletterDomains, loadCategories } from './loaders';
import { ROLE_VAPING, ROLE_WELLNESS_STIMULATION } from '@/app/constants/Roles';
const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
};

export default {
  category: CAT_NEWSLETTER_EMAILS,
  filters: [
    {
      id: 'domain_id',
      label: 'Domain',
      group: groups.general,
      type: FT_AUTOCOMPLETE,
      placeholder: 'Choose domain',
      fieldConf: {
        multiple: false,
        deletebleChips: true,
        chips: true,
        searcher: searchNewsletterDomains,
      },
    },
    {
      id: 'received_on',
      label: 'Received on',
      group: groups.date,
      type: FT_DATE,
    },
    {
      id: 'category_id',
      label: 'Categories',
      group: groups.general,
      type: FT_LIST,
      placeholder: 'Choose categories',
      multiValues: false,
      getListItems: loadCategories,
      disableWithoutRoles: [ROLE_VAPING, ROLE_WELLNESS_STIMULATION],
    },
  ],
  searchBarProp: 'complex_name',
};
